'use client';

import dynamic from 'next/dynamic';
import React, { useEffect, useState } from 'react';
import type { Office } from '@jlg-website/database/types';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';
import { Plus } from 'lucide-react';

const loading = () => <>Loading...</>;

const TestimonialsForm = dynamic(
  () => import('@/components/admin/contents/content-types/testimonials-form'),
  { loading }
);

export function TestimonialsCreateOption({ onCreate }: { onCreate: () => void }) {
  const [open, setOpen] = useState(false);
  const [offices, setOffices] = useState<Pick<Office, 'id' | 'name'>[]>([]);

  const handleSave = () => {
    setOpen(false);
    onCreate();
  };

  useEffect(() => {
    if (!open) return;
    fetch('/admin/api/offices')
      .then((r) => r.json())
      .then(setOffices);
  }, [open]);

  return (
    <Dialog
      open={open}
      onOpenChange={(v) => {
        setOpen(v);
        if (!v) setOffices([]);
      }}
    >
      <DialogTrigger asChild>
        <Button variant="ghost" size="icon" className="h-6 w-6 shrink-0" aria-label="Create">
          <Plus className="h-3.5 w-3.5" />
        </Button>
      </DialogTrigger>
      {open && (
        <DialogContent className="lg:min-w-3xl">
          <DialogHeader>
            <DialogTitle>Create Testimonial</DialogTitle>
            <TestimonialsForm
              offices={offices}
              onSave={handleSave}
              customCancelButton={
                <DialogClose asChild>
                  <Button variant="outline">Cancel</Button>
                </DialogClose>
              }
            />
          </DialogHeader>
        </DialogContent>
      )}
    </Dialog>
  );
}

export default TestimonialsCreateOption;
